import { Injectable } from '@angular/core';
import { Keys } from 'app/common/keys';
import { Utils } from 'app/common/utils';
import { Organisation } from 'app/entities/organisation';

import { ChartService } from '../chart';
import { OrgInfo } from './org.model';
import { OrgStore } from './org.store';

@Injectable({ providedIn: 'root' })
export class OrgService {
    constructor(private orgStore: OrgStore, private chartService: ChartService) {}

    set(organisation: Organisation): void {
        if (this.getOrganisation().id !== null && this.getOrganisation().id !== organisation.id) {
            const userInfo = Utils.getUserInfoFromToken();
            const chartIds = [
                `${Keys.hearAboutUs}_${userInfo.id}`,
                `${Keys.leadSource}_${userInfo.id}`,
                `${Keys.reasonForSelection}_${userInfo.id}`,
                `${Keys.declineByLastStatus}_${userInfo.id}`,
                `${Keys.declineByReasonOrg}_${userInfo.id}`,
            ];
            this.chartService.deleteChartEntityById(chartIds);
        }
        this.orgStore.updateOrg(organisation);
    }

    getOrganisation(): OrgInfo {
        return this.orgStore.getValue();
    }

    getOrgName(): string {
        return this.orgStore.getValue().name;
    }

    resetStore() {
        return this.orgStore.reset();
    }
}
